import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const HorsePower = (props) => {
  return (
    <FormGroup controlId="horsePower">
      <Col componentClass={ControlLabel} sm={5}>
        Horse Power
      </Col>
      <Col sm={7}>
          <FormControl type="text" value={props.horsePower} onChange={props.handleChangeHorsePower}
            autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

HorsePower.propTypes = {
  horsePower: PropTypes.string,
  handleChangeHorsePower: PropTypes.func
};

export default HorsePower;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/horsePower/HorsePower.js